import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function LogoExploration() {
  const variants = [{
    id: 1,
    name: 'Classic Blue',
    description: 'Matches the original AI logo with a solid blue accent.',
    content: <div className="flex flex-col items-center" data-id="element-221">
          <div className="text-4xl tracking-tight flex items-center" data-id="element-222">
            <span className="font-bold text-gray-900" data-id="element-223">swedenmark</span>
            <span className="text-blue-600 mx-2 text-3xl leading-none translate-y-[-2px]" data-id="element-224">
              &bull;
            </span>
            <span className="font-semibold text-blue-600" data-id="element-225">studio</span>
          </div>
        </div>
  }, {
    id: 2,
    name: 'Brand Gradient',
    description: 'Uses the blue-to-red gradient from the existing brand identity.',
    content: <div className="flex flex-col items-center" data-id="element-226">
          <div className="text-4xl tracking-tight flex items-center" data-id="element-227">
            <span className="font-bold text-gray-900" data-id="element-228">swedenmark</span>
            <span className="mx-1 text-4xl leading-none translate-y-[1px] text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-red-500" data-id="element-229">
              &bull;
            </span>
            <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-red-500" data-id="element-230">
              studio
            </span>
          </div>
        </div>
  }, {
    id: 3,
    name: 'Weight Contrast',
    description: 'High contrast between extra bold brand name and light studio text.',
    content: <div className="flex flex-col items-center" data-id="element-231">
          <div className="text-4xl tracking-tight flex items-center" data-id="element-232">
            <span className="font-extrabold text-gray-900" data-id="element-233">swedenmark</span>
            <span className="text-red-500 mx-2 text-3xl leading-none translate-y-[-2px]" data-id="element-234">
              &bull;
            </span>
            <span className="font-light text-gray-600" data-id="element-235">studio</span>
          </div>
        </div>
  }, {
    id: 4,
    name: 'Dark Mode',
    description: 'Optimized for dark backgrounds with a vibrant gradient dot.',
    isDark: true,
    content: <div className="flex flex-col items-center" data-id="element-236">
          <div className="text-4xl tracking-tight flex items-center" data-id="element-237">
            <span className="font-bold text-white" data-id="element-238">swedenmark</span>
            <span className="mx-2 text-3xl leading-none translate-y-[-2px] text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500" data-id="element-239">
              &bull;
            </span>
            <span className="font-medium text-gray-300" data-id="element-240">studio</span>
          </div>
        </div>
  }, {
    id: 5,
    name: 'Square Separator',
    description: 'A more technical feel using a small square instead of a circle.',
    content: <div className="flex flex-col items-center" data-id="element-241">
          <div className="text-4xl tracking-tight flex items-center" data-id="element-242">
            <span className="font-bold text-gray-900" data-id="element-243">swedenmark</span>
            <span className="w-2 h-2 bg-purple-600 mx-3 translate-y-[2px]" data-id="element-244"></span>
            <span className="font-semibold text-purple-600" data-id="element-245">studio</span>
          </div>
        </div>
  }, {
    id: 6,
    name: 'Subtle & Minimal',
    description: 'Medium weight throughout with a subtle gray separator.',
    content: <div className="flex flex-col items-center" data-id="element-246">
          <div className="text-4xl tracking-tight flex items-center" data-id="element-247">
            <span className="font-semibold text-gray-800" data-id="element-248">swedenmark</span>
            <span className="text-gray-300 mx-2 text-3xl leading-none translate-y-[-2px]" data-id="element-249">
              &bull;
            </span>
            <span className="font-medium text-blue-600" data-id="element-250">studio</span>
          </div>
        </div>
  }, {
    id: 7,
    name: 'With Tagline',
    description: 'Includes the studio positioning statement underneath.',
    content: <div className="flex flex-col items-center" data-id="element-251">
          <div className="text-4xl tracking-tight flex items-center mb-2" data-id="element-252">
            <span className="font-bold text-gray-900" data-id="element-253">swedenmark</span>
            <span className="text-blue-600 mx-2 text-3xl leading-none translate-y-[-2px]" data-id="element-254">
              &bull;
            </span>
            <span className="font-semibold text-blue-600" data-id="element-255">studio</span>
          </div>
          <span className="text-sm font-medium text-gray-500 tracking-wide uppercase mt-1" data-id="element-256">
            Design meets technology
          </span>
        </div>
  }, {
    id: 8,
    name: 'Monotone',
    description: 'A clean, single-color approach for maximum versatility.',
    content: <div className="flex flex-col items-center" data-id="element-257">
          <div className="text-4xl tracking-tight flex items-center" data-id="element-258">
            <span className="font-bold text-gray-900" data-id="element-259">swedenmark</span>
            <span className="text-gray-900 mx-2 text-3xl leading-none translate-y-[-2px]" data-id="element-260">
              &bull;
            </span>
            <span className="font-normal text-gray-900" data-id="element-261">studio</span>
          </div>
        </div>
  }];
  return <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-262">
      <div className="max-w-7xl mx-auto" data-id="element-263">
        <div className="mb-12" data-id="element-264">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-900 mb-6 transition-colors" data-id="element-265">
            <ArrowLeftIcon className="mr-2 h-4 w-4" data-id="element-266" />
            Back to Website
          </Link>
          <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight mb-4" data-id="element-267">
            Logo Exploration
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl" data-id="element-268">
            Variations of the Swedenmark Studio logo, matching the clean, modern
            aesthetic of the AI brand while establishing a unique identity for
            the studio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-269">
          {variants.map(variant => <div key={variant.id} className="group relative bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-lg hover:border-blue-300 transition-all duration-300 cursor-pointer flex flex-col h-full" data-id="element-270">
              <div className="p-6 border-b border-gray-100 bg-gray-50/50 flex justify-between items-center group-hover:bg-blue-50/30 transition-colors" data-id="element-271">
                <div data-id="element-272">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-273">
                    Option {variant.id}: {variant.name}
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-274">
                    {variant.description}
                  </p>
                </div>
                <div className="w-6 h-6 rounded-full border-2 border-gray-200 flex items-center justify-center group-hover:border-blue-500 transition-colors" data-id="element-275">
                  <div className="w-2.5 h-2.5 rounded-full bg-blue-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-276"></div>
                </div>
              </div>

              <div className={`flex-grow flex items-center justify-center p-16 ${variant.isDark ? 'bg-gray-900' : 'bg-white'}`} data-id="element-277">
                {variant.content}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}